import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import Slider from '../Slider';
import Edit from '../../icons/Edit';
import Duplicate from '../../icons/Duplicate';
import './Table.css';
import moment from 'moment';


class Table extends Component {
  render() {
		const { columns, rows, handleCancelClick, handleEditClick, handleDuplicateClick, handleActiveClick } = this.props;
    return (
			<table className="table">
				<tr className="table__head">
					{
						columns.map((column, index) => {
							let headStyle = 'table__head-col '
							if (column.width === 'large') headStyle += 'table__col--large';
							else if (column.width === 'medium') headStyle += 'table__col--med';
							else if (column.width === 'small') headStyle += 'table__col--small';
							return (
								<th key={index} className={headStyle}>{column.name}</th>
							)
						})
					}
          {
            handleEditClick &&
            <th className='table__head-col table__col--small'>
              Actions
            </th>
          }
				</tr>
				{
					rows.map((row, index) => {
						let canEdit = _.get(row, 'status') === 'sent' ? false : true;

            if (!this.props.rowPreCheck || this.props.rowPreCheck(row)) {
							let isArchived = row.status === 'archived' ? true : false;
  						return (
  							<tr key={index} className="table__row">
  								{
  									columns.map((head, i) => {
  										let headStyle = 'table__col '
  										if (head.width === 'large') headStyle += 'table__col--large';
  										else if (head.width === 'medium') headStyle += 'table__col--med';
  										else if (head.width === 'small') headStyle += 'table__col--small';
  										if (head.prepData) {
  											return (
  												<td key={`table-${i}`} className={headStyle}>
  													{head.prepData(row)}
  												</td>
  											)
  										} else if (head.isToggle) {
  											return (
  												<td key={`table-${i}`} className='table__col table__col--small'>
                            <Slider
                              isActive={row[head.field] ? row[head.field] : false}
                              handleClick={() => { handleActiveClick(row) }}/>
                          </td>
  											)
  										} else {
  											return (
  												<td key={`table-${i}`} className={headStyle}>
  													{row[head.field]}
  												</td>
  											)
  										}
  									})
  								}
                  { handleEditClick &&
                    <td className='table__col table__col--small'>
											<div className='verticalCenter'>
												{ handleDuplicateClick && <Duplicate title='Duplicate campaign' onClick={() => handleDuplicateClick(row)} /> }
												{ handleDuplicateClick && canEdit && !isArchived && <span className="tableDivider" /> }
												{ canEdit && !isArchived && <Edit title="Edit campaign" onClick={() => { handleEditClick(row) }}/> }
												{ canEdit && !isArchived && handleCancelClick && <span className="tableDivider" /> }
												{ canEdit && !isArchived && handleCancelClick && <a onClick={handleCancelClick.bind(null, row)} className="simple-link">Cancel</a> }
											</div>
                    </td>
                  }
  							</tr>
  						)
						}

						return null;
					})
				}
			</table>
    );
  }
}

Table.Proptypes = {
	 columns: PropTypes.array.isRequired,
	 rows: PropTypes.array.isRequired,
   handleEditClick: PropTypes.func,
   handleDuplicateClick: PropTypes.func,
   handleActiveClick: PropTypes.func,
   rowPreCheck: PropTypes.func
}

export default Table;



/** WEBPACK FOOTER **
 ** ./src/components/Table/index.js
 **/